import { Component } from '@angular/core';
import { MatterAccountingSelectors } from '@state/matter/accounting/accounting.selectors';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterStatementofAccountSelectors } from '@state/matter/statementOfAccounts/statementOfAccounts.selectors';
import { select } from '@ngxs/store';

@Component({
	selector: 'app-ghost-practice',
	templateUrl: './ghost-practice.component.html',
	standalone: false,
})
export class GhostPracticeComponent {
	ghostPracticeNonHstItems = select(
		MatterAccountingSelectors.getGhostPracticeNonZeroNonHstItems,
	);
	ghostPracticeHstItems = select(
		MatterAccountingSelectors.getGhostPracticeNonZeroHstItems,
	);
	ghostPracticeConveyancingFeeItems = select(
		MatterAccountingSelectors.getGhostPracticeNonZeroConvenyancingFeeItems,
	);
	totals = select(MatterStatementofAccountSelectors.statementOfAccountsTotals);
	hst = select(SelectedMatter.matterHST);
}
